import { render, staticRenderFns } from "./appDelivery.vue?vue&type=template&id=2915ec8a&scoped=true&"
import script from "./appDelivery.vue?vue&type=script&lang=js&"
export * from "./appDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2915ec8a",
  null
  
)

export default component.exports